import styled from "styled-components"
import { Link } from "react-router-dom"
import SVGIcon from "components/presenters/common/SVGIcon"

export default function EmptyPayback() {
  return (
    <EmptyPaybackBlock>
      <IconBlock>
        <SVGIcon name={"banknote"} />
      </IconBlock>
      <NoticeComment>{"환급내역이 없어요\n환급 챌린지에 도전해보세요!"}</NoticeComment>
      <RedirectBtn to={`/motishop`}>챌린지 둘러보기</RedirectBtn>
    </EmptyPaybackBlock>
  )
}

const EmptyPaybackBlock = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`

const IconBlock = styled.div`
  width: calc(100vw * (47.6 / 375));
  height: calc(100vw * (35 / 375));
  margin-bottom: calc(100vw * (18 / 375));

  svg {
    color: #d9d9d9;
  }
`

const NoticeComment = styled.span`
  text-align: center;
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: calc(100vw * (23.1 / 375));
  color: #7f7f7f;
  white-space: pre-wrap;
  margin-bottom: calc(100vw * (23 / 375));
`
const RedirectBtn = styled(Link)`
  padding: calc(100vw * (13 / 375)) calc(100vw * (22 / 375));
  font-style: normal;
  font-weight: 500;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (23 / 375));
  text-align: center;
  color: #000000;

  background: #ffcf19;
  border-radius: calc(100vw * (10 / 375));
`
